import request from '@/utils/request'
import Cookies from 'js-cookie'

export function getList (filters = {}, pagination = {}) {
  const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
  //TODO vecchio url (/spm) per recuperare tutti gli SPM senza filtro per protocol Closed  
  return request({
    url: `/list/spm/${is_show_closed_protocol}`,
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/spm/' + id,
    method: 'get'
  })
}

export function remove (id) {
  return request({
    url: '/spm/' + id,
    method: 'delete',
  })
}

export function nextCin (data) {
  return request({
    url: '/next_cin/spm',
    method: 'post',
    data,
  })
}

export function notifySpm (data) {
  return request({
    url: '/notify/spm/' + data.id,
    method: 'post',
    data
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/spm'
  if (data.id) {
    method = 'put'
    url = '/spm/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function uploadPdf (data) {
  return request({
    url: '/pdf/spm/' + data.get('id'),
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function removePdf (id) {
  return request({
    url: '/remove_pdf/spm/' + id,
    method: 'post'
  })
}

export function downloadPdf (id, type, filename, download = true) {
  //issue vari
  var url = '/pdf/spm/' + id;
  if (download)
  {
    url = '/download' + url;
  }
  //issue vari
  return request({
    //issue vari
    url: url,
    //issue vari
    method: 'get',
    responseType: 'blob',
  }).then( response => {
    var newBlob = new Blob([response.data], {type: "application/pdf"});
    var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
    
    if(download) {
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    }

    return fileURL
  })
}

export function exportExcel (filters, filename) {
  return request({
    url: '/export/spm',
    method: 'get',
    responseType: 'blob',
    headers: {
      // 'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  }).then( response => {
    console.log(response)
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', filename);
    document.body.appendChild(fileLink);
    fileLink.click();
  })
}

